const isEnabled = (value: unknown): boolean => value === 'true' || value === '1';

export const FEATURES = {
  rates: isEnabled(import.meta.env.VITE_FEATURE_RATES),
  indices: isEnabled(import.meta.env.VITE_FEATURE_INDICES),
  experiments: isEnabled(import.meta.env.VITE_FEATURE_EXPERIMENTS),
  subIndexCorrelation: isEnabled(import.meta.env.VITE_FEATURE_SUBINDEX_CORRELATION),
  // Paid API plans. Keep off wherever the indexer runs with `billing_enabled = false`,
  // so the Settings nav never offers Checkout against an environment that has no
  // Stripe configuration.
  billing: isEnabled(import.meta.env.VITE_FEATURE_BILLING),
} as const;
